import React, { useEffect, useState } from 'react';
import { CartList } from '../../components/cart-list';
import { Cart as CartInterface } from '../../api/types/vendor/carts-types';
import {
  ModalCartAction,
  ModalCartActionModes,
} from '../../components/modals/modal-cart-action';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { tw } from '../../utils/tailwind';
import { SetOrdersDoneButton } from '../../components/vendor/set-orders-done-button';
import { View } from 'react-native';
import { OrdersNavigation } from '../../components/navigations/orders-navigation';

interface CurrentOrdersListProps {
  isNative: boolean;
  refreshing: boolean;
  orders: CartInterface[];
  onRefresh: () => void;
}

export const CurrentOrdersList = (props: CurrentOrdersListProps) => {
  // States
  const [currentCart, setCurrentCart] = useState<CartInterface>();
  const [modalCartActionOptionsMode, setModalCartActionMode] =
    useState<ModalCartActionModes>('off');

  useEffect(() => {
    const updateLastSeenOrderId = async () => {
      // Retrieve the last seen order ID from AsyncStorage, defaulting to -1 if not found
      const lastSeenOrderId = +(
        (await AsyncStorage.getItem('lastSeenOrderId')) || '-1'
      );

      // Determine the highest order ID from the current orders and the last seen ID
      const newLastSeenId = props.orders.reduce((acc, order) => {
        return Math.max(acc, order.id);
      }, lastSeenOrderId);

      // Store the updated highest order ID back to AsyncStorage
      AsyncStorage.setItem('lastSeenOrderId', newLastSeenId.toString());
    };

    updateLastSeenOrderId();
  }, [props.orders]);

  return (
    <>
      <CartList
        carts={props.orders}
        refreshing={props.refreshing}
        onRefresh={props.onRefresh}
        ListHeaderComponent={
          <>
            <OrdersNavigation />
            <View style={tw`flex-row-reverse`}>
              <SetOrdersDoneButton />
            </View>
          </>
        }
        ListHeaderComponentStyle={[
          props.isNative ? tw`pb-4` : tw`md:pb-3 pb-2`,
          tw`gap-y-4`,
        ]}
        onShowModalCartAction={({ mode, cart }) => {
          setCurrentCart(cart);
          setModalCartActionMode(mode);
        }}
        style={props.isNative ? tw`p-4` : tw`md:p-3 p-2`}
      />

      {/* Show list of cancelation, estimation and delay options */}
      {currentCart ? (
        <ModalCartAction
          mode={modalCartActionOptionsMode}
          cart={currentCart}
          onModalHide={() => {
            setModalCartActionMode('off');
          }}
        />
      ) : null}
    </>
  );
};
